import {
    IPPAScenarioCalculatorCalculateOptions,
    IPPAScenarioCalculator
} from "../PA.PPA.Core/PA.PPAScenario.IF.Aspects";
import { MessageProvider } from "../PA.Core/Basic/Messages";
import { ProgressProvider } from "../PA.Core/Basic/Progress";
import { PPAScenarioBO } from "../PA.PPA.BusinessObjects/PPAScenarioBO";
import { BehaviorSubject } from "rxjs";
import * as _ from "lodash";
import { ASync } from "../PA.Core/Basic/ASync";
import { IMessageProvider, IProgressProvider, MessageType } from "../PA.Core/PA.Core.IF.Basic";
import { GetPPACalcService } from "./PPACalcService"
import { PPACalcResponse } from "./PPACalcService.IF"


export class PPAScenarioCalculator
    implements IPPAScenarioCalculator {

    private _calcMessageProvider: MessageProvider;
    private _calcProgressProvider: ProgressProvider;
    private _calcComplete: BehaviorSubject<PPAScenarioCalculator>;
    private _PPAScenarioBO: PPAScenarioBO


    private _bIsLoaded: boolean

    //   private _CalculateCompleteSubscription: Subscription
    constructor(aBO: PPAScenarioBO) {
        this._calcMessageProvider = new MessageProvider()
        this._calcProgressProvider = new ProgressProvider()
        this._calcComplete = new BehaviorSubject<PPAScenarioCalculator>(this)
        this._PPAScenarioBO = aBO
        this._bIsLoaded = false

    }

    Register(PPAScenarioBO: PPAScenarioBO): void {
        const self = this
        const bo = PPAScenarioBO
        // Currently, we don't listen to anything,.. just on demand calc.

        this.UnRegister()
        this._PPAScenarioBO = PPAScenarioBO

        if (bo) {
            bo.OnLoadComplete
                .then((result) => {
                    return ASync.resolve()
                })
                .then((ignore) => {

                    // Subscribe
                    self._bIsLoaded = true
                })
                .catch((err) => {
                    console.log("Error in PPAScenario Calculator Register(): ", err)
                    self._bIsLoaded = false
                })
        }
    }

    UnRegister(): void {
        this._PPAScenarioBO = undefined
        this._bIsLoaded = false

    }

    private get bIsLoaded(): boolean {
        return this._bIsLoaded
    }


    get CalcProgressProvider(): IProgressProvider {
        return this._calcProgressProvider
    }

    get CalcMessageProvider(): IMessageProvider {
        return this._calcMessageProvider
    }

    get OnCalculateComplete(): BehaviorSubject<PPAScenarioCalculator> {
        return this._calcComplete
    }


    async Calculate(opts: IPPAScenarioCalculatorCalculateOptions): Promise<PPACalcResponse> {
        const self = this
        const aBO: PPAScenarioBO = self._PPAScenarioBO
        if (_.isEmpty(aBO)) {
            return
        }

        try {
            self.CalcMessageProvider.clearMessages()
            self.CalcProgressProvider.start("Calculating PPAScenario")
            self.CalcProgressProvider.setProgressMessage('Saving', 'Validating and Saving PPAScenario')
            let retVal: PPACalcResponse = {
                bSuccess: true,
                sErrors: [],
                sWarnings: [],
                sInfo: []
            }

            // 1.Save (Validate)
            await aBO.Save()
            const aPPAScenarioService = GetPPACalcService()

            if (!aBO.bIsSaved) {
                self.CalcProgressProvider.setProgressMessage('Saving', 'Unable to Save PPAScenario to Calculate')
                self.CalcProgressProvider.finish()
                return
            }

            // 2. Run PPAScenario Evaluator
            self.CalcProgressProvider.setProgressMessage('Calculating', 'Calculating PPAScenario')

            if (opts.type == 'MarketShare')
                retVal = await aPPAScenarioService.CalculateMarketShares(
                    {
                        Type: 'MarketShare',
                        WbPPAScenarioId: aBO.WB_PPAScenario.cif.WB_PPA_SCENARIO_ID
                    }
                )
            else
                retVal = await aPPAScenarioService.CalculateElasticities(
                    {
                        Type: 'Elasticity',
                        WbPPAScenarioId: aBO.WB_PPAScenario.cif.WB_PPA_SCENARIO_ID
                    }
                )

            if (retVal.bSuccess) {
                self.CalcMessageProvider.addMessage({
                    code: 'Success', type: MessageType.Information,
                    title: 'Calculation Completed', description: 'Calculating Completed'
                })

            } else {
                self.CalcMessageProvider.addMessage({
                    code: 'Failed', type: MessageType.Information,
                    title: 'Calculating Failed with Error', description: retVal.sErrors.join("\r")
                })
            }
            // Add Any Warnings
            self._calcMessageProvider.addTextMessages('CalcW', MessageType.Warning, retVal.sWarnings.join("\r"));
            // Add Any Errors
            self._calcMessageProvider.addTextMessages('CalcE', MessageType.Error, retVal.sErrors.join("\r"))

            self.CalcProgressProvider.finish()

            //Update Last Calced Date
            self.OnCalculateComplete.next(self)
            return retVal;
        } catch
            (err) {
            self.CalcProgressProvider.exception(err)
            throw err;
        }

    }
}


